import axios from 'axios'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Logo1 from '../../assets/abf/logo1.png'
import Logo2 from '../../assets/abf/logo2.png'
import config from '../../config/request.config'
import { Container, ContentMini, Form, FormGroup, Label, Logo } from '../login/styled'
import { ButtonSistema } from './style.styled'

interface PropsAuth {
  setPrizeDraw: any
}

interface PropsListDraw {
  code: string,
  name: string,
  phone: string,
}

export default function Prizedraw ({ setPrizeDraw }: PropsAuth) {
  const navigate = useNavigate();
  const [listDraw, setListDraw] = useState<PropsListDraw[]>([])
  const [colocacoesLimitadas, setColocacoesLimitadas] = useState([""])
  // Lista com as colocações, você pode expandir ou reduzir de acordo com sua necessidade
  const colocacoes = ["1º", "2º", "3º", "4º", "5º", "6º", "7º", "8º", "9º", "10º", "11º", "12º", "13º", "14º", "15º"];  
  // const colocacoes = ["1º", "2º", "3º", "4º", "5º"];  

  const getFormDatasPrizeDraw = async () => {
    const user = localStorage.getItem('isAuthenticated')
    try {
      await axios
        .get(`${config.HOST}:${config.PORT}/v1/subscription/draw/${user?.toLowerCase()}`)
        .then((response) => {
          let colocacoesLimitadas
          setListDraw(response.data)
          // Limita o tamanho do array colocacoes para ter a mesma quantidade de elementos que listDraw2
          const len = response.data.length
          if (len > colocacoes.length) {
            colocacoesLimitadas = colocacoes.slice(0, Number(colocacoes.length))
          } else {
            colocacoesLimitadas = colocacoes.slice(0, Number(len))
          }
          setColocacoesLimitadas(colocacoesLimitadas)
        })
        .catch((error) => {
          // alert("Ops, servidor desativado!");
          console.log("ERRRRRO: ", error.message);
        });
    } catch (error) {
      // alert("Ops, servidor desativado!");
      console.log(123, `Erro: ${error}`);
    }
  };
  
  useEffect(() => {
    localStorage.setItem('isAuthenticated', "")
    localStorage.setItem('isPrizeDraw', "true")
    getFormDatasPrizeDraw()
  }, [])
  
  return (
    <>
      {/* LISTA COM OS SORTEADOS */}
      <Container>
        <ContentMini  onClick={() => {
                localStorage.setItem('isAuthenticated', "")
                localStorage.setItem('isPrizeDraw', "true")
                navigate('/login')
              }}>
          <Logo src={Logo1} alt="Logo" />
          <Logo src={Logo2} alt="Logo" />
          <Form>
            <FormGroup>
              <Label htmlFor="pwd" onClick={() => setPrizeDraw(false)} style={{ margin: 'auto', fontSize: '28px', fontWeight: 'bold' }}>SORTEADOS:</Label>            
              <br />
              {/* TABELA COM OS SORTEADOS */}
              <table style={{ width: '90vh', margin: 'auto', fontSize: '20px' }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'right' }}></th>
                    <th style={{ textAlign: 'left', width: '50%' }}>NOME:</th>
                    <th style={{ textAlign: 'left' }}>CADASTRO Nº:</th>
                    <th style={{ textAlign: 'left' }}>TELEFONE:</th>
                  </tr>
                </thead>
                <tbody>
                  {colocacoesLimitadas.map((colocacao, index) => {
                    // Aqui você pode acessar os dados da listDraw2 para preencher cada linha da tabela
                    const sorteado = listDraw[index] // Sorteado da posição atual
                    if (sorteado) {
                      return (
                        <tr key={index}>
                          <td style={{ textAlign: 'right', paddingRight: '15px', fontWeight: 'bold' }}>{colocacoes[index]}</td>
                          <td style={{ textAlign: 'left' }}>{sorteado.name}</td>
                          <td style={{ textAlign: 'left' }}>{sorteado.code}</td>
                          <td style={{ textAlign: 'left' }}>{sorteado.phone}</td>
                        </tr>
                      )
                    }
                  })}
                </tbody>
                <ButtonSistema onClick={() => {
                localStorage.setItem('isAuthenticated', "")
                localStorage.setItem('isPrizeDraw', "true")
                navigate('/login')
              }}>CONCLUIR</ButtonSistema>
              </table>                
            </FormGroup>
          </Form>
        </ContentMini>
      </Container> 
    </>
  )
}